<script>
import { Button, Card, Collapse } from "sveltestrap";
import { from } from './from.js';


let probe_result;

function probe() {
  from('/probe', {method:'GET'})
  .then(j=>j.json())
  .then(j=>{
    probe_result = JSON.stringify(j,null,2);
  })
}

</script>


<!-- <Collapse > -->
  <Card body>
    <p>Token Status</p>
    <p style="white-space:pre-line;" id="token_status"></p>
    <p>Id Token</p>
    <p style="white-space:pre-line;" id="id_token"></p>
    <p>Access Token</p>
    <p style="white-space:pre-line;" id="access_token"></p>
    <p>User Info</p>
    <p style="white-space:pre-line;" id="userInfo"></p>
  </Card>
  <Card body>
    <Button on:click={probe}>Probe data</Button>
  </Card>

  <Card body ><div style="white-space:pre-line;">{probe_result}</div></Card>
<!-- </Collapse> -->
